export default __webpack_public_path__ + "static/services-129aa172f2636ec1c29be131af5b2b34.gif";